import { X } from 'lucide-react'

interface ProcessingProgressModalProps {
  isOpen: boolean
  onClose: () => void
  resourceName: string
  logs: string[]
  progress?: {
    current: number
    total: number
    percentage: number
  }
}

export function ProcessingProgressModal({
  isOpen,
  onClose,
  resourceName,
  logs,
  progress,
}: ProcessingProgressModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[80vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Procesando: {resourceName}
            </h2>
            {progress && (
              <p className="text-sm text-gray-600 mt-1">
                Parte {progress.current} de {progress.total} ({progress.percentage.toFixed(0)}%)
              </p>
            )}
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Progress Bar */}
        {progress && (
          <div className="px-4 pt-4">
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="bg-bmp-green h-2.5 rounded-full transition-all duration-300"
                style={{ width: `${progress.percentage}%` }}
              ></div>
            </div>
          </div>
        )}

        {/* Logs */}
        <div className="flex-1 overflow-y-auto p-4 font-mono text-xs bg-gray-50">
          {logs.length === 0 ? (
            <div className="text-gray-500 text-center py-8">
              Iniciando procesamiento...
            </div>
          ) : (
            <div className="space-y-1">
              {logs.map((log, index) => (
                <div
                  key={index}
                  className={`${
                    log.includes('✅') || log.includes('📊')
                      ? 'text-green-700'
                      : log.includes('❌') || log.includes('Error')
                      ? 'text-red-700'
                      : log.includes('⚠️')
                      ? 'text-yellow-700'
                      : log.includes('📤')
                      ? 'text-blue-700'
                      : 'text-gray-700'
                  }`}
                >
                  {log}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-50 text-xs text-gray-600">
          💡 Puedes cerrar este modal y el procesamiento continuará en segundo plano
        </div>
      </div>
    </div>
  )
}
